export function getImageUrl(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return (process.env.REACT_APP_IMAGE_URL || "") + url;
}
